import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Merchant',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Merchant',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Merchant',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  phone: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  whatsapp: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  instagram: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  gozem: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  location: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  latitude: {
    model_name: 'Merchant',
    column_type: 'decimal',
  },
  longitude: {
    model_name: 'Merchant',
    column_type: 'decimal',
  },
  introduction: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  cashback_percent: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  follows_count: {
    model_name: 'Merchant',
    column_type: 'integer',
  },
  cashback_end_date: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  cashback_start_date: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  cashback_instruction_fr: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  cashback_instruction_en: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  store_owner: {
    model_name: 'Merchant',
    column_type: 'belongs_to',
    extra: {
      association_name: 'store_owner',
      model_name: 'StoreOwner',
      foreign_key: 'store_owner_id',
    },
  },
  store_owner_id: {
    model_name: 'Merchant',
    column_type: 'belongs_to',
    extra: {
      association_name: 'store_owner',
      model_name: 'StoreOwner',
      foreign_key: 'store_owner_id',
    },
  },
  cover: {
    model_name: 'Merchant',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  cover_with_audio: {
    model_name: 'Merchant',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  not_expired_event: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  show_on_places_section: {
    model_name: 'Merchant',
    column_type: 'boolean',
  },
  show_on_catalog: {
    model_name: 'Merchant',
    column_type: 'boolean',
  },
  show_on_explore_section: {
    model_name: 'Merchant',
    column_type: 'boolean',
  },
  position: {
    model_name: 'Merchant',
    column_type: 'integer',
  },
  agent: {
    model_name: 'Merchant',
    column_type: 'string',
  },
  tag_list: {
    model_name: 'Merchant',
    column_type: 'tag',
  },
  explore_tag_list: {
    model_name: 'Merchant',
    column_type: 'tag',
  },
  logo: {
    model_name: 'Merchant',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  logo_with_audio: {
    model_name: 'Merchant',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  images: {
    model_name: 'Merchant',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  images_with_audio: {
    model_name: 'Merchant',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 5,
    },
  },
  collect_qr_code_url: {
    model_name: 'Merchant',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
